import { css } from '@linaria/core';
import { getFormattedDate } from 'modules/Compute/utils';
export const PatOption = ({
  pat
}: {
  pat: CF.API.ApiKeys.KeyData;
}) => {
  const {
    id,
    description,
    created_at
  } = pat;
  return <div className={patOptionStyles.container}>
      <div className={patOptionStyles.key}>{id.slice(0, 5) + '*'.repeat(3)}</div>
      <div className={patOptionStyles.description}>{description || '-'}</div>
      <div className={patOptionStyles.createdDate}>{getFormattedDate(created_at)}</div>
    </div>;
};
const patOptionStyles = {
  container: "odules__Compute__Components__ClusterPAT__PatOption_tsx-container-c1gde2vz",
  key: "odules__Compute__Components__ClusterPAT__PatOption_tsx-key-ktvuzf2",
  description: "odules__Compute__Components__ClusterPAT__PatOption_tsx-description-d1d1nnnc",
  createdDate: "odules__Compute__Components__ClusterPAT__PatOption_tsx-createdDate-c1waljvw"
};

require("./PatOption.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./PatOption.tsx");